<script setup>
import { computed } from 'vue';
import { useToast } from 'cc-prime';
import { useRouter } from 'vue-router';
const router = useRouter();
const toast = useToast();

const hasJobId = computed(() => (data) => {
  return !!data.job?.id;
});

function onViewAction(data) {
  const jobId = data.job?.id;
  if (!jobId) {
    return;
  }
  router.push({ name: 'ActionJobDetail', params: { jobId } });
  toast.removeGroup('runJobToast');
}

const actionTitle = computed(() => (data) => {
  return data.job?.action?.name || '';
});

const statusText = computed(() => (data) => {
  return data.job?.status === 'COMPLETED' ? 'completed successfully' : 'failed';
});

const buttonSeverity = computed(() => (data) => {
  return data.severity;
});
</script>
<template>
  <Toast group="runJobToast" position="top-right">
    <template #message="slotProps">
      <div class="flex flex-auto flex-col items-start gap-2">
        <div class="">
          <span class="font-medium">{{ actionTitle(slotProps.message) }}</span>
          {{ statusText(slotProps.message) }}
        </div>
        <Button
          v-if="hasJobId(slotProps.message)"
          size="small"
          :severity="buttonSeverity(slotProps.message)"
          label="View results"
          @click="onViewAction(slotProps.message)"
        />
      </div>
    </template>
  </Toast>
</template>
